import {
  Box,
  Icon,
  IconName,
  Input,
  MixpanelEvent,
  PowerSearchShortcut,
  useMixpanel,
  usePowerSearchContext,
} from '@talos/kyoko';
import { useCallback } from 'react';
import styled from 'styled-components';

const HEADER_POWER_SEARCH_MIN_WIDTH = 900;

export function PowerSearchButton() {
  const mixpanel = useMixpanel();
  const {
    modal: { open },
  } = usePowerSearchContext();

  const handleOpenPowerSearch = useCallback(() => {
    mixpanel.track(MixpanelEvent.OpenPowerSearch);
    open();
  }, [mixpanel, open]);

  return (
    <PowerSearchButtonWrapper>
      <PowerSearchInput
        data-testid="header-power-search-button"
        aria-label="Open Power Search"
        inputType="search"
        placeholder="Power Search"
        prefix={<Icon icon={IconName.Search} />}
        suffix={
          <Box lineHeight="1.25rem">
            <PowerSearchShortcut />
          </Box>
        }
        onClick={handleOpenPowerSearch}
        width="100%"
      />
    </PowerSearchButtonWrapper>
  );
}

const PowerSearchButtonWrapper = styled.div`
  align-self: center;
  flex: 1 10 0;
  min-width: 80px;
  max-width: 420px;
  overflow: hidden;

  @container header (max-width: ${HEADER_POWER_SEARCH_MIN_WIDTH - 1}px) {
    display: none;
  }
`;

const PowerSearchInput = styled(Input)`
  cursor: pointer;

  input {
    cursor: pointer;
  }
`;
